import React from 'react';

import { Card, CardGroup, Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { insertSpaces } from '../../../utils/strings';
import { useSelector } from 'react-redux';
import MasterPermissions from 'src/Member/api/MasterPermissions';

const SimpleCoverageCards = ({ list }) => {
  const { t } = useTranslation();
  const permissionDrivenList = [];
  const {
    DoNot_Display_Medical_Product,
    DoNot_Display_Dental_Product,
    DoNot_Display_Vision_Product,
    DoNot_Display_Prescription_Product,
  } = useSelector((state) => state.app.appConfigs.Network_Setting);

  if (list.length > 0) {
    list.forEach((eachProduct) => {
      if (eachProduct.product === 'Medical') {
        if (
          !DoNot_Display_Medical_Product &&
          MasterPermissions.CheckPermission('Medical Coverage')
        ) {
          permissionDrivenList.push(eachProduct);
        }
      } else if (eachProduct.product === 'Dental') {
        if (
          !DoNot_Display_Dental_Product &&
          MasterPermissions.CheckPermission('Dental Coverage')
        ) {
          permissionDrivenList.push(eachProduct);
        }
      } else if (eachProduct.product === 'Vision') {
        if (
          !DoNot_Display_Vision_Product &&
          MasterPermissions.CheckPermission('Vision Coverage')
        ) {
          permissionDrivenList.push(eachProduct);
        }
      } else if (eachProduct.product === 'Prescription') {
        if (
          !DoNot_Display_Prescription_Product &&
          MasterPermissions.CheckPermission('Prescription Coverage')
        ) {
          permissionDrivenList.push(eachProduct);
        }
      } else {
        permissionDrivenList.push(eachProduct);
      }
    });
  }

  return (
    <div className="carousel-li-item">
      <div className="item-wrapper">
        {/*<Link to={`/member/coverage?selectedIndex=${activeMemberIndex}&coverageType=${accumulateSummary.Product}`}
          onBlur={() => cardFocus()}
        >
          <Card aria-describedby="productname" aria-live="polite">
            <div id="productname" className="sr-only">{`Details of ${accumulateSummary.Product} Coverage`}</div>
            <Card.Footer className={'text-muted' }>
              <div className="card-footer-content">
                <h3>{insertSpaces( accumulateSummary.Product )}</h3>
                <p className={ accumulatorData.BenefitPlan ? 'plan-name' : 'plan-name invisible'}>{ t( 'member.dashboard.coverage.plan' ) } <span> {accumulateSummary.BenefitPlan && accumulateSummary.BenefitPlan}</span></p>
              </div>
            </Card.Footer>
          </Card>
        </Link> */}

        <Row className="m-0">
          {permissionDrivenList &&
            permissionDrivenList.map((item, index) => {
              return (
                <Col
                  key={index}
                  md={6}
                  xs={6}
                  className={
                    index === 0
                      ? 'p-0 padding-right-10 margin-bottom-10'
                      : index === 0 || index === 2
                      ? 'p-0 padding-right-10'
                      : 'p-0'
                  }
                >
                  <Link
                    to={`/member/coverage?selectedIndex=${'0'}&coverageType=${
                      item.product
                    }`}
                  >
                    <div className={'mini-coverage-card ' + item.product}>
                      <div className="">
                        <div className="h3">{insertSpaces(item.product)}</div>
                        <div className="h5">
                          {insertSpaces(item.benefitPlan)}
                        </div>
                      </div>
                    </div>
                  </Link>
                </Col>
              );
            })}
        </Row>
      </div>
    </div>
  );
};

export default SimpleCoverageCards;
